import React from 'react'
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export default function Logos({ content, pics }) {
  const number = (Object.values(content.logosDetails).length)

  const Pics = pics.edges
 
  return (
    <div id="logos" className={`py-10 ${content.color}`}>
      <p className='text-center text-sm mb-8'><strong>{content.titre}</strong></p>
      <div className='container mx-auto grid grid-cols-2 items-center place-items-center md:flex md:flex-nowrap gap-4'>
        {
          Object.values(content.logosDetails).map((logo, index) => {
            let res = Pics.filter(pic => pic.node.name === logo.img)
            return (
              <div key={index} className={` col-span-1 md:basis-1/${number}`}>
                <GatsbyImage
                key={index}
                fluid={res[0].node.childImageSharp.gatsbyImageData}
                image={getImage(res[0].node)}
                alt='logos clients'
              />
              </div>
            );
          })
        }
      </div>
    </div>
  );
}
